<template>
  <page-wrapper :title="title" :hasPad="true">
    <div class="container">
      <div class="row">
        <div class="col-3 detail" v-if="user">
          <h4>ข้อมูลทั่วไป</h4>
          <hr />
          <p>ชื่อ</p>
          <div class="mb-3">{{user.firstName}}</div>
          <p>นามสกุล</p>
          <div class="mb-3">{{user.lastName}}</div>
          <p>เพศ</p>
          <div class="mb-3">{{user.gender}}</div>
          <p>วันเกิด</p>
          <div class="mb-3">{{user.birthDate}}</div>
          <p>บัตรประชาชน / Passport</p>
          <div class="mb-3">{{user.identifierId}}</div>
          <p>เบอร์โทรศัพท์</p>
          <div class="mb-3">{{user.phoneNumber}}</div>
          <p>อีเมล</p>
          <div class="mb-3">{{user.email }}</div>
          <p>สถานะ</p>
          <div class="mb-3">{{user.status }}</div>
        </div>
        <div class="col-9">
          <div class="row-header">
            <div class="cell">วันที่</div>
            <div class="cell">การกระทำ</div>
            <div class="cell">โดยเจ้าหน้าที่</div>
          </div>
          <user-log-row
            v-for="log in logs"
            v-bind="log"
            :key="log.id"
          ></user-log-row>
        </div>
      </div>
    </div>
  </page-wrapper>
</template>

<script>
import { Input as ElInput } from "element-ui";
import PageWrapper from "@/lib/components/PageWrapper";
import ScButton from "@/lib/components/ScButton";
import { baanRueJaiClient } from "@/dependencies";
import UserLogRow from "../components/UserLogRow";
import { genderMapper, userRole, userRoleMapper } from "@/lib/mapper";
import { toLocaleTH } from "@/lib/dateTime";
import { DateTime } from "luxon";
import { async } from "q";

export default {
  components: {
    PageWrapper,
    ScButton,
    "el-input": ElInput,
    UserLogRow
  },
  data() {
    const title = "บันทึกการเปลี่ยนแปลงข้อมูลผู้ใช้";
    const user = null;

    return {
      title,
      user,
      logs: []
    };
  },
  created() {
    this.setup();
  },
  methods: {
    setup() {
      this.setupData();
    },
    async setupData() {
      await this.setupUser();
      await this.setupLogs();
    },
    async setupUser() {
      const data = await this.fetchUser();
      const { user_profile: profile, user_verify } = data;
      const identifierId = profile.citizen_id || profile.passport_number || "-";
      const isVerified = identifierId !== "-";
      const isVerifiedAsVisitor = isVerified && !Boolean(user_verify);

      const user = {
        email: data.email,
        firstName: profile.first_name,
        lastName: profile.last_name,
        gender: profile.gender ? genderMapper[profile.gender] : "-",
        birthDate: profile.birth_date
          ? toLocaleTH(DateTime.fromISO(profile.birth_date)).toFormat(
              "dd MMMM yyyy"
            )
          : "-",
        identifierId,
        phoneNumber: profile.mobile_number || "-",
        status: isVerified ? "ยืนยันตัวตนแล้ว" : "ยังไม่ยืนยันตัวตน",
        isVerified,
        isVerifiedAsVisitor
      };

      this.user = user;
    },
    async setupLogs() {
      const data = await this.fetchLogs();

      this.logs = data.map(log => {
        const { activity_id: id, title } = log

        const activity = { title };

        const adminName = `${log.admin.first_name} ${log.admin.last_name}`;
        const admin = { name: adminName };

        const createdAt = DateTime.fromISO(log.created_at).toUTC();

        return {
          id,
          activity,
          createdAt,
          admin
        }
      });
    },
    async fetchUser() {
      const { id } = this.$route.params;
      const response = await baanRueJaiClient.admin.users.get(id);

      return response.data.result;
    },
    async fetchLogs() {
      const { id } = this.$route.params;
      const response = await baanRueJaiClient.admin.users.listAdminLogs(id);

      return response.data.result;
    }
  }
};
</script>

<style lang="scss" scoped>
@import "~@/lib/scss/variables";
.wrapper {
  padding: ($space / 2) $space;
}

.row-header {
  display: grid;
  grid-template-columns: repeat(3, 1fr) 150px;
  padding: ($space / 3) $space;

  grid-gap: 15px;

  border-bottom: $border;

  font-weight: bold;
}
.detail {
  border-right: $border;
}
</style>



// WEBPACK FOOTER //
// src/features/managements/modules/users/pages/UserLogPage.vue